import { Component, OnInit } from '@angular/core';
import { ITrainingItemGroupDetailsView } from '../models/training-item-group-details-view';
import { TrainingItemPersistenceService } from '../services/training-item-persistence.service';
import { PanelList } from '../../shared/models/panel-list';
import { FilterMenu } from '../../shared/models/filter-menu';
import { SortMenu } from '../../shared/models/sort-menu';
import { ILinkedTrainingItemDetails } from '../models/linked-training-item-details';
import { CommonService } from '../../shared/services/common.service';

@Component({
  selector: 'app-training-item-group-details',
  templateUrl: './training-item-group-details.component.html',
  styleUrls: ['./training-item-group-details.component.scss']
})
export class TrainingItemGroupDetailsComponent implements OnInit {
  selectedTrainingItemGroupForEdit: ITrainingItemGroupDetailsView | null = null;
  istrainingItemsLoaded: boolean = true;
  trainingItemGroupListModalInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableToggling: false,
    enableSelection: false
  };
  constructor(private trainingItemPersistenceService: TrainingItemPersistenceService,
    private commonService: CommonService) {
  }
  ngOnInit(): void {
    this.selectedTrainingItemGroupForEdit = this.trainingItemPersistenceService.getSelectedTrainingItemGroupForEdit();
    this.bindDocumentTemplates(this.selectedTrainingItemGroupForEdit!.linkedTrainingItems)
  }
  bindDocumentTemplates = (linkedItems: ILinkedTrainingItemDetails[]) => {
    linkedItems.sort((a: ILinkedTrainingItemDetails, b: ILinkedTrainingItemDetails) => a.title.localeCompare(b.title));
    this.trainingItemGroupListModalInput.lists = linkedItems;
    this.trainingItemGroupListModalInput.filters = this.getFiltersForDocumentTemplateList();
    this.trainingItemGroupListModalInput.sort = this.getSortFieldsForDocumentTemplateList();
    this.trainingItemGroupListModalInput.clearSelection = true;
    this.istrainingItemsLoaded = !this.commonService.IsListEmpty(linkedItems);
    this.trainingItemGroupListModalInput = { ...this.trainingItemGroupListModalInput };
  }
  openDocument(number: string, version: number | null, trainingItemType: number) {
    if (trainingItemType === 1 && version !== null) {
      var url = location.origin.concat("/eqms.documentDetails/", number, ":", version.toString());
      window.open(url, "_blank");
    }
    else if (trainingItemType === 2) {
      var url = location.origin.concat("/training/eqms.courses/", number);
      window.open(url, "_blank");
    }
  }
  private getFiltersForDocumentTemplateList = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'Type',
        filterFieldName: 'trainingTypeName',
      },
      { 
        filterDisplayName: 'Scheduled',
        filterFieldName: 'scheduledValue',
      },
      {
        filterDisplayName: 'eQMS Scope(s)',
        filterFieldName: 'eqmsScopeNames',
      }
    );
    return filters;
  };
  private getSortFieldsForDocumentTemplateList = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'Type',
        sortFieldName: 'type',
      },
      {
        sortFieldDisplayName: 'Scheduled',
        sortFieldName: 'scheduledValue',
      },
      {
        sortFieldDisplayName: 'eQMS Scope(s)',
        sortFieldName: 'eqmsScopeNames',
      }
    );
    return sortMenu;
  };
}
